import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import CreateVehicleVehicleStatus from "../../../container/Vehicles/VehicleVehicleStatusScreen/CreateVehicleVehicleStatus";
import VehicleVehicleStatusScreen from "../../../container/Vehicles/VehicleVehicleStatusScreen";

const VehicleVehicleStatusRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLESTATUS.HOME}
          element={<VehicleVehicleStatusScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLESTATUS.CREATE}
          element={<CreateVehicleVehicleStatus />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_VEHICLESTATUS.EDIT}
          element={<CreateVehicleVehicleStatus isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleVehicleStatusRoutes;
